import React, { Component } from "react";
import {Promotional} from '../../Components/Home';

import { bindActionCreators } from "redux";
import { connect } from "react-redux";

import * as loginActions from '../../Actions/login';

class Home extends Component {

  componentDidMount() {
    this.props.getToken();
  }

  render() {
    return (
      <div>

        <Promotional />
        
      </div>
    )
  }
}

const mapStateToProps = state => ({ login: state.login });
const mapDispatchToProps = dispatch => bindActionCreators(loginActions, dispatch);
export default connect(mapStateToProps, mapDispatchToProps)(Home);



// WEBPACK FOOTER //
// ./src/Views/Home/index.js